import { useTranslation } from "react-i18next";
import React from "react";

export function Text({ value }) {
  const { t } = useTranslation();
  return <>{t(value) || null}</>;
}
